export const convertNumericStringToNumber = (input_string) => {
    return !isNaN(input_string) ? parseFloat(input_string) : input_string;
}